export default "__VITE_ASSET__Baooun3i__"